/* eslint-disable */
/**
 * All API urls and other constants will reside here.
 */

export const BASE_API_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:3000'
export const BASE_APPLY_URL =
  process.env.REACT_APP_APPLY_URL || 'http://localhost:3002'
export const GET_COMPANY = (name) =>
  `${BASE_API_URL}/companies-jobs?action=getCompany&name=${name}`
export const GET_JOB = (id) =>
  `${BASE_API_URL}/companies-jobs?action=getJob&id=${id}`
export const GET_FILTERED_COMPANY = `${BASE_API_URL}/companies-jobs?action=getFilteredCompany`
